export default [
  // 404 Handling
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "site" */ '@/views/site/NotFound')
  },
  // Catch-All
  {
    path: '*',
    redirect: to => {
      return { name: '404', query: { from: to.fullPath } }
    }
  }
]